var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12ZM3.80078 4.40039C3.5799 4.40039 3.40044 4.57894 3.40039 4.7998V12.2002C3.40055 12.421 3.57997 12.5996 3.80078 12.5996H12.2002C12.421 12.5996 12.6004 12.421 12.6006 12.2002V4.7998C12.6005 4.57894 12.4211 4.40039 12.2002 4.40039H3.80078Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 5C11.8205 5 12 5.17948 12 5.40039V11.5996C12 11.8205 11.8205 12 11.5996 12H4.40039C4.17948 12 4 11.8205 4 11.5996V5.40039C4 5.17948 4.17948 5 4.40039 5H11.5996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitSummary);
export default __webpack_public_path__ + "static/media/visit-summary.e0ef752acc37fa3a2a0ff1c00e0643ed.svg";
export { ForwardRef as ReactComponent };